<template>
    <div class="layer-content common">
        <div class="info2 mgb10">원하시는 카드를 선택해주세요.</div>
        <ul class="__layer-cho-card">
            <li v-for="(cardInfo, index) in billCardList"
                :key="'cardInfo' + index"
                @click="selBillCardSn = cardInfo.billCardSn"><!-- 반복 -->
                <section>
                    <a href="javascript:;"
                       :class="selBillCardSn == cardInfo.billCardSn ? 'current' : ''"><!-- 선택 시 current -->
                        <div class="__cd-name">{{$onbiLib.searchCardBnkNm(cardInfo.cardBankCode, cardInfo.cardCode)}}</div>
                        <div class="__cd-num">
                            <span>{{cardInfo.cardNum.substring(0, 4)}}</span>
                            <span>{{cardInfo.cardNum.substring(4, 8)}}</span>
                            <span>{{cardInfo.cardNum.substring(8, 12)}}</span>
                            <span>{{cardInfo.cardNum.substring(12)}}</span>
                        </div>
                        <div class="__over">{{$onbiLib.searchCardNm(cardInfo.cardCode)}}</div>
                    </a>
                </section>
            </li>
            <li @click="regNewBillCard()">
                <section>
                    <a href="javascript:;" class="__add-card">+ 새카드 등록</a>
                </section>
            </li>
        </ul>
        <div class="btn-wrap center mgt20">
            <button class="big _bt-navy" @click="regBillCard()">
                <span>카드 등록</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'billCardList_popup',
        props: ['index','param', 'popupIndex'],
        data: function(){
            return {
                curBillCardSn:'',
                billCardList : new Array(),
                selBillCardSn : '',
                regNewBillCardFunc:null,
                regBillCardFunc:null,
            }
        },
        computed:{
            selBillCardInfo:function(){
                const _this = this;
                const billCardInfo = this.billCardList.find(function(info){
                    return info.billCardSn == _this.selBillCardSn;
                });
                return billCardInfo;
            }
        },
        methods : {
            regNewBillCard:function(){
                this.$store.commit('closePopup',this.index);
                this.regNewBillCardFunc();
            },
            regBillCard : function(){
                if(this.validCheck()) return false;

                if(!confirm('선택하신 카드를 결제카드로 설정하시겠습니까?')){
                    return false;
                }

                this.regBillCardFunc(this.selBillCardInfo,this.index);
            },
            validCheck : function(){
                if(this.selBillCardSn == '' || this.selBillCardSn == null){
                    this.$toasted.show('결제할 카드를 선택해주세요.');
                    return true;
                }

                if(this.curBillCardSn != ''){
                    if(this.curBillCardSn == this.selBillCardSn){
                        this.$toasted.show('변경할 결제카드를 선택해주세요.');
                        return true;
                    }
                }

                return false;
            }
        },
        mounted : function(){
            const param = this.param;

            this.billCardList       = param.billCardList;
            this.regNewBillCardFunc = param.regNewBillCardFunc;
            this.regBillCardFunc    = param.regBillCardFunc;

            if(param.billCardSn == ''){
                if(this.billCardList != 'undefined'){
                    if(this.billCardList.length > 0){
                        this.selBillCardSn = this.billCardList[0].billCardSn;
                    }
                }
            }else{
                this.selBillCardSn = param.billCardSn;
                this.curBillCardSn = param.billCardSn;
            }
        }
    }
</script>

<style scoped>

</style>